import React from 'react'
import CloudStorage from '../../CloudStorage/CloudStorage'
import { Tooltip } from "react-tooltip";
import { bidtooltipinfo } from './Tooltips/tooltip';

export default function CommonWhiteTooltip({ title, info = "" }) {
    return (
        <>
            {title} &nbsp;
            <img
                data-tooltip-id="my-tooltip-2"
                src={`${CloudStorage.cloudurl}/Assets/Images/project/penalty.svg`}
                alt=""
            />

            <Tooltip
                id="my-tooltip-2"
                place="bottom"
                content={info ? info : bidtooltipinfo}
            />
        </>
    )
}
